import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { SvgIconRegistryService } from 'angular-svg-icon';

type Icon = {
	iconName: string;
	iconData: string
}

interface IconsConfig {
  iconImageFiles?: Array<string>;
  customIcons?: Array<Icon>
}

@Injectable({ providedIn: 'root' })
export class IconPreloaderService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly svgRegistry: SvgIconRegistryService,
  ) {}

  async initialize(): Promise<void> {
    const configUrl = '././static/assets/json/icons.json';
    const config: IconsConfig = await firstValueFrom(this.httpClient.get<IconsConfig>(configUrl));

    if (!config || !config.customIcons || config.customIcons.length === 0) {
      return;
    }

    for (const { iconName, iconData } of config.customIcons) {
      if (!iconName || !iconData) {
        continue;
      }

      this.svgRegistry.addSvg(iconName, iconData);
    }
  }
}


